import { createClient } from "@supabase/supabase-js";

// Set these in Netlify env vars (and a local .env for dev):
// REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_ANON_KEY
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  // Marketing tables live in the "marketing" schema of the JG CRM project
  db: { schema: "marketing" },
});
